import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Box, BottomNavigation, BottomNavigationAction, AppBar, Toolbar, Typography, IconButton } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ListAltIcon from '@mui/icons-material/ListAlt';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from '../../hooks/useAuth';
import { IcpFooter } from './IcpFooter';

/** 底部Tab项（2026-09-06：分账入口移入个人中心，第四Tab改为「我的」） */
const tabs = [
  { label: '首页', icon: <HomeIcon />, path: '/m/home' },
  { label: '录入', icon: <PersonAddIcon />, path: '/m/realname' },
  { label: '记录', icon: <ListAltIcon />, path: '/m/records' },
  { label: '我的', icon: <AccountCircleIcon />, path: '/m/profile' },
];

/**
 * 手机端主框架
 * 顶部标题栏 + 内容区 + 底部Tab导航
 */
export function MobileLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const currentTab = tabs.findIndex((t) => location.pathname.startsWith(t.path));

  const handleLogout = async () => {
    await logout();
    navigate('/m/login');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: '480px', mx: 'auto', bgcolor: 'background.default' }}>
      {/* 顶部栏 */}
      <AppBar position="sticky" color="primary">
        <Toolbar sx={{ minHeight: '52px !important' }}>
          <Typography variant="subtitle1" fontWeight={600} sx={{ flexGrow: 1 }}>
            {tabs.find((t) => location.pathname.startsWith(t.path))?.label || '流量卡代理'}
          </Typography>
          <Typography variant="caption" sx={{ mr: 1, opacity: 0.9 }}>
            {user?.real_name}
          </Typography>
          <IconButton size="small" color="inherit" onClick={handleLogout}>
            <LogoutIcon fontSize="small" />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* 内容区 */}
      <Box component="main" sx={{ flexGrow: 1, pb: '56px', overflowY: 'auto' }}>
        <Outlet />
        <IcpFooter />
      </Box>

      {/* 底部Tab栏 */}
      <BottomNavigation
        value={currentTab >= 0 ? currentTab : 0}
        showLabels
        sx={{
          position: 'fixed',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          width: '100%',
          maxWidth: '480px',
          borderTop: 1,
          borderColor: 'divider',
          zIndex: 1000,
        }}
        onChange={(_e, newValue) => {
          navigate(tabs[newValue].path);
        }}
      >
        {tabs.map((tab) => (
          <BottomNavigationAction key={tab.path} label={tab.label} icon={tab.icon} />
        ))}
      </BottomNavigation>
    </Box>
  );
}
